/* ==========================================================================
   Variant switching for the delivery / inventory line (FAT-298)

   Lived inline in snippets/inventory.liquid, which renders once per product
   card: a collection page shipped 20 copies of this listener, so every
   variant:change was handled 20 times over. Loaded once from
   layout/theme.liquid instead.
   ========================================================================== */
document.addEventListener('variant:change', function (e) {
  var variantId = e.detail && e.detail.variant && e.detail.variant.id;
  var formId = (e.detail && e.detail.formId) || (e.target && e.target.id);
  if (!variantId) return;

  // With a form ID, only touch the inventory line bound to that form;
  // otherwise the main product's (the one without a form attribute)
  var inventoryElements = formId
    ? document.querySelectorAll('variant-inventory[form="' + formId + '"]')
    : document.querySelectorAll('variant-inventory:not([form])');

  inventoryElements.forEach(function (inventory) {
    inventory.querySelectorAll('[data-variant-id]').forEach(function (element) {
      if (element.getAttribute('data-variant-id') === variantId.toString()) {
        element.removeAttribute('hidden');
      } else {
        element.setAttribute('hidden', '');
      }
    });
  });
});
